
import React from 'react';


interface LoadMoreIndicatorProps {
  isFetchingNextPage: boolean;
  loadMoreRef: React.RefObject<HTMLDivElement>;
}

export const LoadMoreIndicator: React.FC<LoadMoreIndicatorProps> = ({
  isFetchingNextPage,
  loadMoreRef
}) => {
  return (
    <div 
      ref={loadMoreRef}
      className="flex justify-center items-center my-8 h-12"
    >
      {isFetchingNextPage && (
        <span className="text-sm font-medium bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent animate-pulse px-3 py-1.5 rounded-md">
          Loading...
        </span>
      )}
    </div>
  );
};
